import { App } from '@capacitor/app';
import { Browser } from '@capacitor/browser';
import { jwtDecode } from 'jwt-decode';
import router from '@/router';
import { ROUTES } from '@myorg/type-lib';
import { exchangeCodeForToken } from '@/services/auth/oauthApi';
import { useAuthFacade } from '@/auth/facade/authFacade';
import { logger } from '@myorg/type-lib';

const CALLBACK = 'bloomingriceapp://oauth2/callback';

export function setupDeepLinkListener() {
  App.addListener('appUrlOpen', async ({ url }) => {
    if (!url.startsWith(CALLBACK)) return;

    try {
      await Browser.close();

      const parsed = new URL(url);
      const code = parsed.searchParams.get('code');

      if (!code) {
        logger.error('No auth code received');
        return;
      }

      const tokens = await exchangeCodeForToken(code);

      const decoded: any = jwtDecode(tokens.access_token);

      const user = {
        userId: decoded.userId || decoded.sub || '',
        merchantId: decoded.merchantId || '',
        name: decoded.username || decoded.name || decoded.sub || '',
        roles: decoded.roles || [],
      };

      const authFacade = useAuthFacade();
      await authFacade.handleLoginSuccess(tokens, user);

      router.push(ROUTES.USER.PATH);
    } catch (err) {
      logger.error('OAuth callback failed:', err);
    }
  });
}